import { render } from "./temperature.vue?vue&type=template&id=49943f61&scoped=true"
import script from "./temperature.vue?vue&type=script&lang=js"
export * from "./temperature.vue?vue&type=script&lang=js"

import "./temperature.vue?vue&type=style&index=0&id=49943f61&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49943f61"]])

export default __exports__